import { useDispatch } from 'react-redux';
import tempLogo from '../../static/images/temporary_logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { emptyFilters } from '../../redux/filtersSlice.js';
import LanguageSelector from './LanguageSelector.jsx';
import { useTranslation } from 'react-i18next';

const DesktopBar = ({ isLogged, user, level }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogoClick = () => {
        dispatch(emptyFilters());
        navigate("/")
    }
    return (
        <div className="w-full xl:w-[1000px] flex">

            {/* Left */}
            <div className='flex-1 flex items-center justify-start gap-2 p-4'>

                {/* Logo */}
                <img src={tempLogo} alt="TicinoWild Logo" className='w-56 cursor-pointer' onClick={handleLogoClick} />
            </div>

            {/* Right */}
            <div className='flex-1 flex items-center justify-end gap-2 p-4'>

                {/* Attività */}
                {
                    isLogged && level === 2 &&
                    <div className='flex gap-2'>
                        {/* <Link to="/handle-shop"><div className='flex gap-2 items-center border rounded py-1 px-2'>
                            <div>{t('NavBar.shop')}</div>
                            <i className="fi fi-rr-shop mb-[-5px]"></i>
                        </div></Link> */}
                        <Link to="/handle-activities">
                            <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                                <div className="pt-1"><i className="fi fi-rr-list-timeline text-2xl text text-[#225424]"></i></div>
                                <div className="hidden md:flex">{t('NavBar.manage')}</div>
                                {/* <i className="fi fi-rs-navigation mb-[-5px]"></i> */}
                            </div></Link>
                    </div>
                }

                {/* Preferiti */}
                {
                    isLogged &&
                    <Link to="/favourites"><div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                        <div className="pt-1"><i className="fi fi-rs-heart text-2xl text text-[#225424]"></i></div>
                        <div>Preferiti</div>
                    </div></Link>
                }

                {/* Accedi registrati */}
                {
                    !isLogged &&
                    <div className="flex gap-4 items-center">
                        <Link to="/register-login?section=Login"><div className='bg-white py-2 px-3 rounded-xl'>{t('NavBar.signIn')}</div></Link>
                        {/* <GreenButton text="Registrati" link="/register-login?section=Register" /> */}
                    </div>
                }
                {
                    isLogged &&
                    <Link to="/my-profile">
                        <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                            <div className="pt-1"><i className="fi fi-rr-user text-2xl text text-[#225424]"></i></div>
                            <div className="hidden md:flex">{t('NavBar.profile')}</div>
                        </div>
                    </Link>
                }
                <LanguageSelector />
            </div>

        </div>
    )
}

export default DesktopBar;